/**
 * Where "home" is for each role — where sign-in lands them, where "Go to
 * Dashboard" and the "g h" chord go.
 *
 * Staff land on today's attendance: the school dashboard is built on the
 * admin metrics API (financial figures), which serves admins and principals
 * only, so /dashboard could only ever show staff "Access Restricted".
 */

import type { UserRoleValue } from "@/constants";

export const homePathForRole = (role: UserRoleValue | null | undefined): string => {
  switch (role) {
    case "parent":
      return "/parent/dashboard";
    case "teacher":
      return "/teacher/dashboard";
    case "super_user":
      return "/platform";
    case "staff":
      return "/attendance";
    case "admin":
    case "principal":
      return "/dashboard";
    default:
      return "/login";
  }
};
